import React, { useEffect, useState } from 'react';
import './style.css';
import { toast } from 'react-toastify';
import './profileStyle.css';
import { useNavigate } from "react-router-dom";
import storeCreationIcon from '../../../assets/icons/store-registration.svg';
import branchsIcon from '../../../assets/icons/branch.svg';
import categoriesIcon from '../../../assets/icons/category.svg';
import productsIcon from '../../../assets/icons/products.svg';
import deploymentIcon from '../../../assets/icons/settings.svg';
import GetRequest from '../../../service/GetRequest';
import ProfileIntiationLablesContainer from '../../../components/DashboardComponents/ProfileIntiationLablesContainer';
import DashboardProgressBar from '../../../components/DashboardComponents/DashboardProgressBar';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import CookieHandler from '../../LandingPage/Authentication/CookieHandler'

const CompleteProfileStepsPage = ({ setActivePath }) => {
  const userId = CookieHandler.getCookie("userid");
  const navigate = useNavigate();

  const [storeId, setStoreId] = useState("0");
  const [isStoreCreated, setIsStoreCreated] = useState("AWAIT");
  const [isBranchAdded, setIsBranchAdded] = useState("AWAIT");
  const [isCategoriesCreated, setIsCategoriesCreated] = useState("AWAIT");
  const [isProductAdded, setIsProductAdded] = useState("AWAIT");
  const [isDeployed, setIsDeployed] = useState("AWAIT");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setActivePath("Dashboard");

    GetRequest("v1/store-management-service/dashboard/status", true)
      .then(response => {
        if (!response || response === undefined) {
          console.log("No store found for this user");
        } else {
          console.log(response);
          setIsStoreCreated(response.isStoreCreated);
          setIsBranchAdded(response.isBranchAdded);
          setIsCategoriesCreated(response.isCategoriesListed);
          setIsProductAdded(response.isProductsListed);
          setIsDeployed(response.isDeployed);

          if (response.isStoreCreated === "COMPLETED") {
            GetRequest("v1/store-management-service/view/my/store", true)
              .then(storeResponse => {
                if (!storeResponse || storeResponse === undefined) {
                  console.log("No store found for this user");
                } else {
                  console.log(storeResponse);
                  setStoreId(storeResponse.id);
                }
              })
              .catch(storeError => {
                console.error("Error fetching store data:", storeError);
                toast.error("An error occurred while fetching store data. Please try again later.");
              });
          }

          if (response.isDeployed === "COMPLETED") {
            navigate('/store');
          }
        }
      })
      .catch(error => {
        console.error("Error fetching store status:", error);
        toast.error("An error occurred while fetching store status. Please try again later.");
      });

    setTimeout(() => {
      setIsLoading(false);
    }, 2000); // Simulate a 2-second loading period
  }, [setActivePath, userId, navigate]);

  if (isLoading) {
    return (
      <div className="outlet-container">
        <div className="background-white">
          <div className="background-white-sub-container">
          <br /><br />
          <div className="center-text-align">
          <div className="center-text-align">Your Account status</div><br /><br />
                <Skeleton height={100} width={800} />
          </div>
          <br /><br /><br />
            <Skeleton height={85} width="100%" />
            <Skeleton height={85} width="100%" />
            <Skeleton height={85} width="100%" />
            <Skeleton height={85} width="100%" />
            <Skeleton height={85} width="100%" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="outlet-container">
      <div className="background-white">
        <div className="background-white-sub-container">
          <br /><br />
          <div className="center-text-align">
            <div className="center-text-align">Your Account status</div><br /><br />
            <DashboardProgressBar isStoreCreated={isStoreCreated} isBranchAdded={isBranchAdded} isCategoriesCreated={isCategoriesCreated} isProductAdded={isProductAdded} isDeployed={isDeployed} />
          </div>
          <br /><br /><br />
          <ProfileIntiationLablesContainer title="Complete Store details" description="Add store details like color, font theme etc" status={isStoreCreated} navigation="/store/register" icon={storeCreationIcon} iconBackgroundColor="#A09BE6" actionName="Get Started" isActionRequired />
          <ProfileIntiationLablesContainer title="Add Branches" description="Add store details like color, font theme etc" status={isBranchAdded} navigation={`/store/add/branch/${storeId}`} icon={branchsIcon} iconBackgroundColor="#59BFF1" actionName="Continue" isActionRequired />
          <ProfileIntiationLablesContainer title="Create Categories" description="Add store details like color, font theme etc" status={isCategoriesCreated} navigation="/store/add/categories" icon={categoriesIcon} iconBackgroundColor="#CE7B69" actionName="Continue" isActionRequired />
          <ProfileIntiationLablesContainer title="Add Products or Services" description="Add store details like color, font theme etc" status={isProductAdded} navigation="/store/branch/intialisation/add/products" icon={productsIcon} iconBackgroundColor="#80CA88" actionName="Continue" isActionRequired />
          <ProfileIntiationLablesContainer title="Create Your First Deploy" description="Add store details like color, font theme etc" status={isDeployed} navigation={`/store/intiate/deploy/${storeId}`} icon={deploymentIcon} iconBackgroundColor="#FB9A08" actionName="Continue" isActionRequired />
        </div>
      </div>
    </div>
  );
};

export default CompleteProfileStepsPage;